<template>
  <f7-sheet class="high darker" :backdrop="true" :opened="show" @sheet:closed="$emit('closed')">
    <f7-toolbar>
      <div class="left"></div>
      <div class="right">
        <f7-link sheet-close>
          Sluiten
        </f7-link>
      </div>
    </f7-toolbar>
<!--      <f7-block>-->
<!--        <f7-block-title>Toon tijden om de:</f7-block-title>-->
<!--        <f7-segmented strong>-->
<!--          <f7-button @click.native="update_calendar_interval(30)"-->
<!--            :active="interval === 30"-->
<!--          >-->
<!--            30 minuten-->
<!--          </f7-button>-->
<!--          <f7-button @click.native="update_calendar_interval(60)"-->
<!--            :active="interval === 60"-->
<!--          >-->
<!--            60 minuten-->
<!--          </f7-button>-->
<!--        </f7-segmented>-->
<!--      </f7-block>-->

      <f7-block>
        <f7-block-title>Duur van de training <small>(minuten)</small></f7-block-title>
        <f7-segmented strong>
          <f7-button @click="update_calendar_duration(30)"
            :active="duration === 30"
          >
            30
          </f7-button>
          <f7-button @click="update_calendar_duration(60)"
            :active="duration === 60"
          >
            60
          </f7-button>
          <f7-button @click="update_calendar_duration(90)"
            :active="duration === 90"
          >
            90
          </f7-button>
          <f7-button @click="update_calendar_duration(120)"
            :active="duration === 120"
          >
            120
          </f7-button>
        </f7-segmented>
      </f7-block>
  </f7-sheet>
</template>

<script>

    export default {
        components: {},

        props: [
            'show',
        ],

        mixins: [],

        data: function () {
            return {
                //
            };
        },

        computed: {
            interval: {
              set(value) {
                this.$store.commit('training_slots/set_state', {
                  property: 'interval',
                  value: value,
                })
              },
              get() {
                return this.$store.state.training_slots.interval;
              }
            },
            duration: {
              set(value) {
                this.$store.commit('training_slots/set_state', {
                  property: 'duration',
                  value: value,
                })
              },
              get() {
                return this.$store.state.training_slots.duration;
              }
            }
        },

        created() {
            //
        },

        mounted() {
            //
        },

        methods: {
            update_calendar_interval(minutes) {
              this.interval = minutes;
            },
            update_calendar_duration(minutes) {
              this.duration = minutes;
              // this.$store.dispatch('notifications/addWarningNotification', {
              //   message: 'Sowwy.. het aanpassen van de trainingsduur werkt nog niet!',
              //   closeButton: false,
              // })
            },
        },

        watch: {
            //
        }
    };
</script>
